import { Link } from "eddev/routing"
import { MenuItemFieldsFragment } from "../../types.graphql"
import { cn } from "@utils/tw"
import { ReactNode } from "react"

export const DropdownMenu = ({
  menu,
  className,
}: {
  menu: MenuItemFieldsFragment[]
  className?: string
  extras?: ReactNode
}) => {
  return (
    <div className={cn("flex items-center gap-2 py-2 type-label-s", className)}>
      {menu?.map((item) => (
        <div key={item?.label} className="p-3 first:pl-0 last:pr-0 relative group shrink-0">
          <Link
            href={item?.url!}
            target={item?.target!}
            className="transition-all duration-300 border-b border-b-transparent hover:border-b-blue group-hover:border-b-blue py-1"
          >
            {item?.label}
          </Link>
          {item?.childItems?.nodes?.length! > 0 && (
            <div className="absolute z-[50] w-headerDropdownW top-full left-0 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-all duration-300">
              <div className="mt-1 w-full border border-blue bg-white">
                {item?.childItems?.nodes.map((child) => (
                  <Link
                    key={child?.label}
                    href={child?.url!}
                    target={child?.target!}
                    className="block px-5 py-4 border-b border-b-blue last:border-b-0"
                  >
                    {child?.label}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
